import type { ComponentRef } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';

import type { Observable } from 'rxjs';

import type { NotificationBodyBase } from './notification-body-base';
import type { NotificationConfig, NotificationStyle } from './notification-config';
import type { NotificationHostBase } from './notification-host-base';
import type { NotificationsContainerComponent } from './notifications-container/notifications-container.component';

export class NotificationRef<
  NotificationBody extends NotificationBodyBase = NotificationBodyBase,
  NotificationHost extends NotificationHostBase = NotificationHostBase,
> {
  public bodyRef: ComponentRef<NotificationBody>;
  public groupIdentifier?: string;
  public host?: NotificationsContainerComponent;
  public config?: NotificationConfig;
  private _hostRef: ComponentRef<NotificationHost>;

  public set hostRef(ref: ComponentRef<NotificationHost>) {
    ref.location.nativeElement.classList.add('notification-component-host');
    this._hostRef = ref;
  }

  public get hostRef(): ComponentRef<NotificationHost> {
    return this._hostRef;
  }

  public onClick(): Observable<any> {
    return outputToObservable(this.hostRef.instance.hostClick);
  }

  public topButtonClick(): Observable<void> {
    return outputToObservable(this.hostRef.instance.topButtonClick);
  }

  public close(): void {
    this.hostRef.instance.close();
    this.hostRef.instance.afterClosed.subscribe(() => this.hostRef.destroy());
  }

  public get beforeClose(): Observable<any> {
    return this.hostRef.instance.beforeClose;
  }

  public get afterClosed(): Observable<any> {
    return this.hostRef.instance.afterClosed;
  }

  public set style(style: NotificationStyle) {
    this.hostRef.instance.setStyle(style);
  }

  public set title(title: string) {
    this.bodyRef.instance.setTitle(title);
  }

  public get title(): string {
    return this.bodyRef.instance.title!;
  }

  public set message(message: string | null) {
    this.bodyRef.instance.setMessage(message);
  }

  public get message(): string {
    return this.bodyRef.instance.message!;
  }

  public set messageHTML(messageHTML: string) {
    this.bodyRef.instance.setMessageHTML(messageHTML);
  }

  public get messageHTML(): string {
    return this.bodyRef.instance.messageHTML!;
  }
}
